import z from 'zod';

export const SchoolTicketViewSchema = z.object({
  description: z.string().optional(),
  name: z.string().min(1, 'Nome é obrigatório'),
  timeOfTicket: z.string().optional(), // ou .datetime().optional() se for ISO
  cpf: z.string().optional(),
  phone: z.string().optional(),
  image: z.string().optional(),
  reponsableId: z.string().optional(),
  isValid: z.boolean().optional(),
});

export type SchoolTicketFormInput = z.infer<typeof SchoolTicketViewSchema>;
